module.exports = __webpack_public_path__ + "img/under-water.bad92501.jpeg";